import { AUTH_ACTION_TYPES } from './AuthOperations';
import { auth, database } from '../../firebase';
import { pick } from 'lodash';

const signedIn = (user) => {
  return {
    type: AUTH_ACTION_TYPES.SIGN_IN,
    email: user.email,
    displayName: user.displayName,
    photoURL: user.photoURL,
    uid: user.uid,
    charityKey: user.charityKey,
    phone: user.phone,
    role: user.role
  };
};

const signedOut = () => {
  return {
    type: AUTH_ACTION_TYPES.SIGN_OUT
  };
};

export const startListeningToAuthChanges = () => {
  return (dispatch) => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        const usersRef = database.ref('users');
        usersRef.child(user.uid).once('value', function(snapshot) {
          const userData = snapshot.val();
          const userFromAuth = pick(user, [ 'displayName', 'email', 'uid', 'photoURL' ])
          dispatch(signedIn({...userFromAuth, ...userData}));
          // usersRef.child(user.uid)
          // .set({...userData, ...userFromAuth});
          database.ref('admins').child(user.uid)
            .once('value')
            .then(snapshot => {
              if (snapshot.val()) {
                dispatch({ type: AUTH_ACTION_TYPES.SET_AS_ADMIN });
              }
            });
        })
      } else {
        dispatch(signedOut());
      }
    });
  };
};
